<div class="container">
  <nav class="navbar navbar-expand navbar-dark bg-dark menu-frame">
    <ng-container *ngIf="authStateService.isReady">
      <!-- ✅ DYNAMIC MENU -->
      <app-menu *ngIf="loginDisplay"></app-menu>

      <!-- ✅ LOGIN (when logged out) -->
      <div *ngIf="!loginDisplay" class="navbar-nav">
        <a
          class="nav-item nav-link pointer-link"
          role="button"
          tabindex="0"
          (click)="login()"
          (keydown.enter)="login()"
          (keydown.space)="login()">
          Login
        </a>
      </div>
      <!-- ✅ USER INFO / LOGOUT -->
      <div
        *ngIf="loginDisplay"
        class="navbar-nav ms-auto d-flex flex-row align-items-center">

        <span class="nav-item nav-link text-white-50 small mb-0">
          ({{ userName }})
        </span>

        <a class="nav-item nav-link pointer-link" (click)="logout()">
          Logout
        </a>
      </div>
    </ng-container>
  </nav>
</div>

<!-- ✅ LOADING OVERLAY -->
<div class="app-container bg-light">
  <div *ngIf="isLoading$ | async" class="loading-overlay">
    <div class="loading-box">
      <div class="spinner"></div>
      <p>Processing, please wait...</p>
    </div>
  </div> 

  <!-- ✅ MAIN CONTENT -->
  <!-- <div class="container main-content" style="min-height: 90vh; "> -->
  <div class="container main-content">  
    <main>
      <router-outlet></router-outlet>
    </main>
  </div>


  <!-- ✅ FOOTER -->
  <div class="container">
    <footer class="app-footer">
      <span class="footer-text">
        Powered by xPetro Systems, LLC</span>
       <!-- ✅ GLOBAL ALERTS -->
       <app-alert></app-alert>
    </footer>
  </div>
</div>
